import { OcrConfidence } from '../types';

/**
 * Maps OCR confidence enum values to human-readable labels
 * '0' = special case when Gemini skips the crop
 * '1' = low confidence
 * '2' = medium confidence
 * '3' = high confidence
 */
export const mapOcrConfidenceToLabel = (confidence: OcrConfidence): string => {
  switch (confidence) {
    case OcrConfidence.SKIPPED: // '0'
      return 'skipped';
    case OcrConfidence.LOW: // '1'
      return 'low';
    case OcrConfidence.MEDIUM: // '2'
      return 'medium';
    case OcrConfidence.HIGH: // '3'
      return 'high';
    default:
      return 'unknown';
  }
};

/**
 * Gets the CSS class for confidence badge styling
 */
export const getConfidenceClass = (confidence: OcrConfidence): string => {
  switch (confidence) {
    case OcrConfidence.SKIPPED: // '0'
      return 'bg-gray-100 text-gray-600'; // skipped
    case OcrConfidence.LOW: // '1'
      return 'bg-red-100 text-red-700'; // low
    case OcrConfidence.MEDIUM: // '2'
      return 'bg-yellow-100 text-yellow-700'; // medium
    case OcrConfidence.HIGH: // '3'
      return 'bg-green-100 text-green-700'; // high
    default:
      return 'bg-gray-100 text-gray-600'; // unknown
  }
};
